import { Table } from "@package/subframe/components/Table";
import {
  FeatherChevronDown,
  FeatherChevronsUpDown,
  FeatherChevronUp,
} from "@subframe/core";

import type { SortDir } from "@/lib/category-display";

/**
 * A clickable table header that toggles server-side sort for its column.
 * Clicking cycles asc → desc; clicking a different column selects it (asc).
 * Generic over the sort-column union so each list screen keeps its own
 * API-matching allow-list.
 */
export function SortableHeaderCell<T extends string>({
  column,
  label,
  activeColumn,
  activeDir,
  onSort,
  alignRight,
}: {
  column: T;
  label: string;
  activeColumn?: T;
  activeDir: SortDir;
  onSort: (column: T) => void;
  alignRight?: boolean;
}) {
  const isActive = activeColumn === column;
  return (
    <Table.HeaderCell variant={alignRight ? "aligned-right" : undefined}>
      <button
        type="button"
        onClick={() => onSort(column)}
        className="flex items-center gap-1 text-inherit hover:text-default-font"
      >
        <span>{label}</span>
        {isActive ? (
          activeDir === "asc" ? (
            <FeatherChevronUp className="h-3.5 w-3.5" />
          ) : (
            <FeatherChevronDown className="h-3.5 w-3.5" />
          )
        ) : (
          <FeatherChevronsUpDown className="h-3.5 w-3.5 text-neutral-400" />
        )}
      </button>
    </Table.HeaderCell>
  );
}
